import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';
import { useIsMedicalDoctor } from '@web-app/hooks/useIsMedicalDoctor';
import { useRouter } from 'next/router';

/**
 * Controls access to the Non-Appointment Hours tracking page (and its sidebar
 * entry).
 *
 * Priority (highest to lowest):
 * 1. URL query parameter `?canViewTracking=true` — always grants access.
 * 2. GrowthBook flag `non-appointment-hours-tracking` AND the provider is a
 *    prescriber (`is_prescriber` in Airtable), via the `isMedicalDoctor` attribute.
 *
 * Returns `isLoading: true` while the MD lookup is in flight so callers can
 * avoid redirecting users off the page before the entitlement is known.
 */
export const useNonAppointmentHoursTrackingEnabled = (): {
  enabled: boolean;
  isLoading: boolean;
} => {
  const router = useRouter();
  const growthBookEnabled = useFeatureIsOn(
    GROWTHBOOK_FEATURE_FLAGS.NON_APPOINTMENT_HOURS_TRACKING,
  );
  const { isLoading } = useIsMedicalDoctor();

  if (router.query.canViewTracking === 'true') {
    return { enabled: true, isLoading: false };
  }

  return {
    enabled: growthBookEnabled,
    isLoading,
  };
};
